import { createRootRoute, Outlet } from "@tanstack/react-router";
import { AppShell } from "@/components/layout/AppShell";
import { AuthProvider } from "@/components/auth/AuthProvider";
import { NotFoundPage } from "@/pages/NotFoundPage";

/**
 * Root route. Wraps the entire tree with the auth bootstrap (AuthProvider
 * fetches /api/auth/me on first mount) and the AppShell layout.
 *
 * File-based routing — generated route tree lives in `src/routeTree.gen.ts`.
 */
export const Route = createRootRoute({
  component: RootLayout,
  notFoundComponent: NotFoundPage,
});

function RootLayout() {
  return (
    <AuthProvider>
      <AppShell>
        <Outlet />
      </AppShell>
    </AuthProvider>
  );
}
